import getDaysInMonth from 'date-fns/getDaysInMonth';

import { NavigationPeriodId } from '@atlassian/eoc-schedule-common';

import { NowLocation } from './constants/schedule';

// TODO: move to schedule common
/**
 * @returns Before | After | InRange
 */
const getNowLocation = (startEpoch: number, endEpoch: number, nowEpoch: number) => {
	if (nowEpoch > endEpoch) {
		return NowLocation.After;
	}

	if (nowEpoch < startEpoch) {
		return NowLocation.Before;
	}

	return NowLocation.InRange;
};

// TODO: move to schedule common
const getNumberOfDays = ({
	timelineType,
	currentDate,
}: {
	timelineType: NavigationPeriodId;
	currentDate: Date;
}): number => {
	switch (timelineType) {
		case NavigationPeriodId.OneDay:
			return 1;
		case NavigationPeriodId.OneWeek:
			return 7;
		case NavigationPeriodId.TwoWeeks:
			return 14;
		case NavigationPeriodId.OneMonth:
			return getDaysInMonth(currentDate);
	}
};

export { getNowLocation, getNumberOfDays };
